<script>
  import Link from '../../../utils/link';
  import Card from '../../../components/containers/card.html';
  import Avatar from '../../../components/containers/avatar.html';
  import moment from 'moment';

  export let program;

  let nextEvent = program.events.find((event) => {
    return moment(event.date).valueOf() > Date.now();
  })
  let nextEventDate = nextEvent ? moment(nextEvent.date).format('dddd MMMM Do, YYYY') : 'None';

  function getProgramLink() {
    return `/programs/view/${program.id}`;
  }
</script>

<Card hover>
  <Link href={getProgramLink()}>
    <div class="u--padall">
    <div class="grid-x grid-margin-x">
     
      <div class="cell small-12 medium-9">
        <h3>
          {program.name}
        </h3>
      </div>
    </div>
  </div>
  <hr />
  <div class="stat">
    <div class="grid-x">
      <div class="cell small-12 medium-12">
        <h4>Next Event</h4>
        <h5>{nextEventDate}</h5>
      </div>
      <div class="cell small-12 medium-12">
        <h4>Total Events</h4>
        <h5>{program.events.length}</h5>
      </div>
    </div>
  </div>
  </Link>
</Card>


